import { useParams, useSearchParams } from "react-router-dom"
import { useGetBillingTermsByListingIdQuery, useGetInvoicesByListingIdQuery, useLazyGetInvoiceDetailsByInvoiceIdQuery, useSetInvoicePaymentProfileOverrideMutation } from "../../../../../../redux/slices/billingSlice"
import { useLazyFetchNetSuiteInvoiceQuery, useSyncListingInvoiceToNetSuiteMutation } from "../../../../../../redux/slices/integrationsSlice"
import { useEffect, useState } from "react";
import { showErrorNotification } from "../../../../../../redux/actions";
import { useDispatch } from "react-redux";

const useInvoices = () => {
    const dispatch = useDispatch()
    const { id: partnerListingId } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        data: invoices,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useGetInvoicesByListingIdQuery(partnerListingId)

    const {
        data: billingTerms,
        billingTermsIsLoading,
        billingTermsIsFetching,
        billingTermsIsSuccess,
        billingTermsIsError,
        billingTermsError,
    } = useGetBillingTermsByListingIdQuery(partnerListingId)

    const [fetchDetails] = useLazyGetInvoiceDetailsByInvoiceIdQuery()
    const [invoiceDetails, setInvoiceDetails] = useState(null)
    const [isDetailsLoading, setIsDetailsLoading] = useState(null)
    const [detailsError, setDetailsError] = useState(null)
    const [syncInvoice] = useSyncListingInvoiceToNetSuiteMutation()
    const [fetchInvoice] = useLazyFetchNetSuiteInvoiceQuery()
    const [setPaymentProfileOverride] = useSetInvoicePaymentProfileOverrideMutation()

    const getDetails = async (invoiceId) => {
        setInvoiceDetails(null)
        const {
            data: details,
            isLoading: loading,
            isError: detailsError
        } = await fetchDetails(invoiceId);
        setIsDetailsLoading(loading)
        setInvoiceDetails(details)
        setDetailsError(detailsError)
    }

    const onClickSyncInvoice = (invoiceId) => {
        return syncInvoice(invoiceId);
    }

    const onClickSetPaymentProfileOverride = (invoiceId, paymentType) => {
        return setPaymentProfileOverride({ invoiceId, paymentType });
    }

    const onClickViewInvoice = async (billingInvoiceId) => {
        const {
            data: invoiceResponse,
            isError: invoiceError
        } = await fetchInvoice(billingInvoiceId);

        if (invoiceResponse && invoiceResponse.netSuiteUrl) {
            window.open(invoiceResponse.netSuiteUrl, '_blank');
        }
        else if (invoiceError) {
            dispatch(showErrorNotification(`There was an error while attempting to view this invoice in NetSuite`))
        }
        else {
            dispatch(showErrorNotification(`This invoice doesn't exist in NetSuite`))
        }
    }

    useEffect(() => {
        if (!searchParams.get('invoiceId')) {
            setInvoiceDetails(null)
        } else {
            getDetails(searchParams.get('invoiceId'))
        }
    }, [searchParams])

    return {
        invoices,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
        invoiceDetails,
        billingTerms,
        detailsError,
        onClickSyncInvoice,
        onClickViewInvoice,
        onClickSetPaymentProfileOverride,
    }
}

export default useInvoices